import React, { useContext, useEffect, useRef, useState } from "react";
import GeneralSwiper from "../swipers/GeneralSwiper";
import Tabs from "../Tabs/Tabs";
import SingleUnitCardContent from "./SingleUnitCardContent";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import { handleWheel } from "@/app/utils/helperFunctions";

interface SingleUnitCardProps {
	data: any; // or define the type of data more specifically
	setMasterplanSelectedUnit: React.Dispatch<React.SetStateAction<any>>;
	setActiveUnitCard: React.Dispatch<React.SetStateAction<boolean>>;
	insideAmenitiesDetailsPage?: boolean;
	optimizedImage?: boolean;
}

const SingleUnitCard: React.FC<SingleUnitCardProps> = ({
	data,
	setMasterplanSelectedUnit,
	setActiveUnitCard,
	insideAmenitiesDetailsPage,
	optimizedImage,
}: SingleUnitCardProps) => {
	const [activeTab, setActiveTab] = useState<string | number>("exterior");
	const { isIpad, isMobile, isReady } = useContext(screenSizeContext);
	const [tabsData, setTabsData] = useState<any[]>();
	

	const imagesByTab =
		data?.unit_type &&
		data?.media
			?.filter((media: any) => {
				if (isMobile) {
					return media.pivot.media_device === "mobile";
				} else {
					return media.pivot.media_device === "desktop";
				}
			})
			?.sort((a: any, b: any) => a.pivot.order - b.pivot.order)
			?.reduce((acc: any, media: any) => {
				const slug = media.pivot.slug;
				if (!acc[slug]) {
					acc[slug] = [];
				}
				acc[slug].push({
					src: process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL + media.media_name,
					alt: media.alt_text || "",
					id: media.id,
				});
				return acc;
			}, {});

	useEffect(() => {
		if (!isReady || !imagesByTab) return;
			const nextTabs = Object.keys(imagesByTab).map((key) => ({
				title: key.replace(/_/g, " "),
				value: key,
			}));
			setTabsData(nextTabs);
		// imagesByTab is derived from isMobile/isIpad + data; recompute when viewport is ready.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isIpad, isMobile, isReady, data]);

	useEffect(() => {
		if (tabsData && tabsData.length > 0) {
			setActiveTab(tabsData[0].value);
		}
	}, [tabsData]);

	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		// document.body.classList.add("no-scroll")
		containerRef.current?.addEventListener("wheel", handleWheel, {
			passive: false,
		});
		return () => {
			containerRef.current?.removeEventListener("wheel", handleWheel);
			// document.body.classList.remove("no-scroll")
		};
	}, []);
	

	return (
		<div className="SingleUnitCard h-full flex flex-col min-h-0 relative" ref={containerRef}>
			{!isIpad && tabsData && (
				<div className="SingleUnitCard_tabs absolute top-[1.5rem] left-[1.125rem] lg:left-[2.5rem] z-10 ">
					<Tabs
						data={tabsData}
						activeTab={activeTab}
						setActiveTab={setActiveTab}
					/>
				</div>
			)}
			<div className="relative shrink-0">
				{isIpad && tabsData && (
					<div className="SingleUnitCard_tabs absolute bottom-0 left-[1.125rem] lg:left-[2.5rem] z-10 ">
						<Tabs
							data={tabsData}
							activeTab={activeTab}
							setActiveTab={setActiveTab}
						/>
					</div>
				)}
				<GeneralSwiper
					key={activeTab}
					images={
						data?.unit_type
							? imagesByTab[activeTab]
							: [
									{
										id: data?.id,
										src:
											process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
											data?.image?.media_name,
										alt: data?.image?.alt_text || "",
									},
							  ]
					}
					slidesPerView={1}
					ImgHeight="h-[40vh] md:h-[30vh] lg:h-[60vh]"
					optimizedImage={optimizedImage}
				/>
			</div>
			<div className="SingleUnitCard_content p-[1.125rem] lg:p-[.5rem] flex-1 min-h-0 overflow-hidden">
				{/* {(isIpad || isMobile) && tabsData && (
					<div className="SingleUnitCard_tabs_mobile   z-10 ">
						<Tabs
							data={tabsData}
							activeTab={activeTab}
							setActiveTab={setActiveTab}
						/>
					</div>
				)} */}
				<SingleUnitCardContent
					facility={data?.unit_type ? false : true}
					data={data}
					setMasterplanSelectedUnit={setMasterplanSelectedUnit}
					setActiveUnitCard={setActiveUnitCard}
					insideAmenitiesDetailsPage={insideAmenitiesDetailsPage}
				/>
			</div>
		</div>
	);
};

export default SingleUnitCard;
